import { createSlice, PayloadAction } from "@reduxjs/toolkit";

function formatDate(date: Date): string {
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    const isSameDay = (d1: Date, d2: Date) =>
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate();

    if (isSameDay(date, now)) {
        return "Today";
    } else if (isSameDay(date, yesterday)) {
        return "Yesterday";
    } else {
        const oneWeekAgo = new Date(now);
        oneWeekAgo.setDate(now.getDate() - 7);

        if (date > oneWeekAgo) {
            return date.toLocaleDateString("en-US", { weekday: "long" });
        } else {
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    }
}

interface ChatState {
    currentReciever: User | null;
    messages: Record<string, ChatMessage[]>;
}

const initialState: ChatState = {
    currentReciever: null,
    messages: {}, // Initialize messages as an empty object
};

export const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        setCurrentChatReciever: (state, action: PayloadAction<User | null>) => {
            state.currentReciever = action.payload;
        },
        setMessages: (state, action: PayloadAction<Record<string, ChatMessage[]>>) => {
            state.messages = action.payload;
        },
        addMessage: (state, action: PayloadAction<ChatMessage>) => {
            const message = action.payload;

            if (!message.created_at) return;

            const dateKey = formatDate(new Date(message.created_at));
            if (!state.messages[dateKey]) {
                state.messages[dateKey] = [];
            }
            state.messages[dateKey].push(message);
        },
    },
});

export default chatSlice.reducer;
export const { setCurrentChatReciever, setMessages, addMessage } = chatSlice.actions;